<template>
  <div>
    <h1>Développement informatique</h1>
    <p>&#60; Think - code - inspire &#47; &#62;</p>
    <img src="@/assets/avatar.svg" alt="me" class="avatar" />
  </div>
</template>

<script>
export default {
  name: 'Header'
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 28px;
  margin-bottom: 0;
  color: var(--black);
}

p {
  text-transform: uppercase;
  font-size: 1.1em;
  margin: 0 auto 50px;
  color: var(--black);
  overflow: hidden;
  white-space: nowrap;
  width: 0;
  animation: animatedtext 4s steps(40, end) 1s 1 normal both;
}

@keyframes animatedtext {
  from {
    width: 0;
  }
  to {
    width: 80%;
  }
}

.avatar {
  display: block;
  width: 40vw;
  margin-right: auto;
  margin-left: auto;
}

@media only screen and (min-width: 720px) and (max-width: 1023px) {
  .avatar {
    width: 30vw;
  }
}
@media screen and (min-width: 1024px) {
  h1 {
    font-size: 2.5em;
  }
  p {
    font-size: 1.3em;
    margin: 0 auto 56px;
  }
  .avatar {
    width: 20vw;
  }
}
</style>
